module.exports = __webpack_public_path__ + "img/chambre.d1da2598.jpeg";